import React from 'react';
import HistoryTableHeader from './historyTableHeader';
import { TrialRejectedDevicesTableColumnCaptions } from './tableColumnCaptions';

const TrialRejectedDeviceHistoryTableHeader = (props) => {
  const { editedFields, objectData } = props;

  const title = [{
    title: TrialRejectedDevicesTableColumnCaptions.device.key,
    value: objectData ? objectData.device.key : '',
  }];

  return <HistoryTableHeader editedFields={editedFields} captions={TrialRejectedDevicesTableColumnCaptions} objectData={objectData} title={title}/>
};

export default TrialRejectedDeviceHistoryTableHeader;


// WEBPACK FOOTER //
// ./src/components/trialRejectedDeviceHistoryTableHeader.js